<div class="card-container" [ngClass]="background">
  <ng-content></ng-content>
</div>
